type Props = { onClick: () => void; hidden?: boolean };

export default function FloatingConsult({ onClick, hidden = false }: Props) {
  return (
    <button
      onClick={onClick}
      aria-label="Open online consultation"
      aria-hidden={hidden}
      tabIndex={hidden ? -1 : 0}
      className={`consult-glass fixed z-[90] right-6 md:right-10 bottom-10 md:bottom-16 flex items-center gap-2 px-5 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-300 ${
        hidden ? "opacity-0 translate-y-3 pointer-events-none" : "opacity-100 translate-y-0"
      }`}
    >
      <i className="ri-chat-3-line text-[15px] text-brand" aria-hidden="true" />
      Online Consultation
    </button>
  );
}